import LeftIcon from "@/assets/images/icons/left_16.svg?inline";
import RightIcon from "@/assets/images/icons/right_16.svg?inline";

export default {
  name: "pagination",

  props: ["params"],

  data() {
    return {
      currentPage: this.params.currentPage
    };
  },

  watch: {
    params: function() {
      this.currentPage = this.params.currentPage;
    },

    currentPage: function(newValue) {
      this.$emit("handleChangePage", newValue);
    }
  },

  computed: {},

  methods: {},

  components: {
    LeftIcon,
    RightIcon
  }
};
